module.exports = __webpack_public_path__ + "img/exam_jan_2025_7kozbxha.6f9fedff.jpg";